import { useTranslation } from 'react-i18next';

import routes from "../Constants/routes";
import { UserRoles} from "../Constants/userRoles";
import {FeatureFlags} from "./featureFlags";
import useCustomerNavigation from "../Hooks/Customer/useCustomerNavigation";
import useFeatureFlags from "../Hooks/useFeatureFlags";
import useUserAccess from "../Hooks/useUserAccess";
import settingsRoutes from "../Constants/Settings/settingsRoutes";


export const useSettingsNavigationItems = (user) => {
    const { t } = useTranslation();
    const { isFeatureEnabled } = useFeatureFlags()
    const { hasAdminAccess } = useUserAccess();
    const spcsAdmin = hasAdminAccess(UserRoles.Spcs);
    
    const items = [
        {
            link: {
                label:t('customernavigation.sales'),
                subItems: [
                    {
                        link: {
                            label:t("topnavigation.discounts"),
                            route: routes.discounts,
                        },
                        disabled: !hasAdminAccess(UserRoles.Discounts)
                    },
                    {
                        link: {
                            label: t('navigation.priceadjustment'),
                            route: routes.vossPriceAdjustments
                        }
                    },
                    {
                        link: {
                            label:t('navigation.leadslists'),
                            route: routes.settingsLeadLists
                        },
                        disabled: false
                    },
                    {
                        link: {
                            label:t('navigation.compensation'),
                            route:routes.settingsCompensation
                        },
                        disabled: !hasAdminAccess(UserRoles.Compensation)
                    },
                    {
                        link: {
                            label:t('navigation.orderapprovalrequests'),
                            route: routes.orderApprovalRequests
                        },
                        disabled: !hasAdminAccess(UserRoles.OrderApproval)
                    },
                    {
                        link: {
                            label:t('navigation.quotationfaq'),
                            route: routes.settingsQuotationFaq
                        },
                        disabled: !spcsAdmin
                    },
                    {
                        link: {
                            label:t("navigation.terminationreasons"),
                            route: routes.icaTerminationReasons
                        },
                        disabled: !hasAdminAccess(UserRoles.AdministratorSkynet)
                    },
                ]
            }
        },
        {   
            link: {
                label:t("navigation.invoicing"),
                subItems: [
                    {
                        link: {
                            label:t('navigation.bokaMeraOrders'),
                            route: routes.bokameraadmin
                        },
                        disabled: !hasAdminAccess(UserRoles.BokaMera)
                    },
                    {
                        link: {
                            label:t("common.voss"),
                            route:routes.invoicing
                        },
                        disabled: !hasAdminAccess(UserRoles.Invoicing),
                        hidden: !isFeatureEnabled(FeatureFlags.VOSS_2308_Invoicing)
                    }
                ]
            }
            
        },
        {
            link: {
                label:t("common.customer"),
                subItems: [
                    {
                        link: {
                            label:t("navigation.log"),
                            route: settingsRoutes.Log
                        },
                        disabled: false
                    },
                    {
                        link: {
                            label:t("navigation.infotypes"),
                            route: routes.settingsCustomerInfoTypes
                        },
                        disabled: !hasAdminAccess(UserRoles.Spcs)
                    },
                    {
                        link: {
                            label:t('navigation.hittabyra'),
                            route: routes.hittaByra
                        },
                        disabled: !hasAdminAccess(UserRoles.AOSales)
                    },
                    {
                        link: {
                            label:t('navigation.hittapartner'),
                            route: routes.hittaPartner
                        },
                        disabled: !hasAdminAccess(UserRoles.PartnerSales)
                    },
                ]
            }
        },
        {
            link: {
                label:t("navigation.users"),
                subItems: [
                    {
                        link: {
                            label:t("navigation.permissions"),
                            route: routes.settingsAdminUsers
                        },
                        disabled: !hasAdminAccess(UserRoles.User)
                    },
                    {
                        link: {
                            label:t("navigation.budget"),
                            route: routes.budget
                        },
                        disabled: !spcsAdmin
                    },
                ]
            }
        },
        {
            link: {
                label: t('navigation.priceSimulation'),
                subItems: [
                    {
                        link: {
                            label: t('navigation.simulation'),
                            route: routes.priceSimulation
                        },
                        disabled: !hasAdminAccess(UserRoles.PriceSimulation)
                    },
                    {
                        link: {
                            label: t('navigation.scheduling'),
                            route: routes.priceSimulation
                        },
                        disabled: true
                    },
                    {
                        link: {
                            label: t('navigation.internalPricing'),
                            route: routes.priceSimulation
                        },
                        disabled: true
                    }
                ]
            }
        },
        {
            link: {
                label:t('navigation.system'),
                subItems: [
                    {
                        link: {
                            label:t('navigation.releaseNews'),
                            route: routes.releaseNews
                        },
                    },
                    {
                        link: {
                            label:t('navigation.featureToggles'),
                            route: routes.settingsFeatureToggles
                        },
                    },
                    {
                        link: {
                            label:t('navigation.workerJobs'),
                            route: routes.settingsWorkerJobs
                        },
                    },
                    {
                        link: {
                            label:"Configuration",
                            route: routes.settingsConfiguration
                        },
                    },
                    {
                        link: {
                            label:"System action log",
                            route: routes.settingsSystemActionLog
                        },
                    },
                    {
                        link: {
                            label: "GDPR",
                            route: settingsRoutes.Gdpr
                        },
                        hidden: !isFeatureEnabled(FeatureFlags.VSCO_3081_GDPR_USER_INTERFACE),
                    }
                ],
            },
            hidden: !hasAdminAccess(UserRoles.AdministratorSkynet),
            disabled: !hasAdminAccess(UserRoles.AdministratorSkynet)
        },
        {
            link: {
                label:t('navigation.productversion'),
                route: routes.editProductVersions
            },
            disabled: !hasAdminAccess(UserRoles.ProductOverview)
        },
        {
            link: {
                label:t('navigation.emailtemplates'),
                route: routes.settingsEmailTemplates
            },
            disabled: !hasAdminAccess(UserRoles.EmailTemplate)
        },
        {
            link: {
                label:t("navigation.eloqua"),
                route: routes.eloqua
            },
            disabled: !hasAdminAccess(UserRoles.Eloqua)
        },
        {
            link: {
                label:t("navigation.targetGroups"),
                route: routes.vossTargetGroups
            },
            disabled: !hasAdminAccess(UserRoles.AdministratorSkynet)
        },
        {
            link: {
                label: t('navigation.bankruptcytermination'),
                route: routes.bankruptcyTermination
            },
            disabled: !hasAdminAccess(UserRoles.BankruptcyTermination)
        }
    ]

    sortNavigationItems(items);
    
    return items; 
};
const sortNavigationItems = (items) => {
    items.sort((a, b) => a.link.label.localeCompare(b.link.label, undefined, {numeric: true}));
    items.forEach(item => {
        if (item.link.subItems) {
            sortNavigationItems(item.link.subItems);
        }
    });
};
export const useCustomerNavigationItems = () => {
    const { categorizedItems, processNavItems } = useCustomerNavigation();

    let items = categorizedItems();
    items = processNavItems(items);
    return items;
}